






















import { defineComponent } from "@vue/composition-api";
import { ListFields } from "@/types";

export default defineComponent({
  name: "BaseInputRadio",
  props: {
    name: { type: String, default: "" },
    value: { type: [String, Boolean, Number], default: "" },
    options: { type: Array as () => ListFields, required: true },
  },
  methods: {
    onInput(value: any) {
      this.$emit("input", value);
    },
  },
});
